import React from "react";

const Breadcrums = () => {
  return (
    <div className=" max-w-6xl mx-auto py-4 md:px-0 px-6 ">
      <div className="flex items-center gap-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"  
          fill="none"   
          viewBox="0 0 24 24"
          strokeWidth="1.5"  
          stroke="currentColor"
          className="size-4"  
        >
          <path  
            strokeLinecap="round"
            strokeLinejoin="round"  
            d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
          />  
        </svg>    

        <span>  
          <svg 
            xmlns="http://www.w3.org/2000/svg"   
            fill="none" 
            viewBox="0 0 24 24" 
            strokeWidth="1.5"    
            stroke="currentColor"   
            className="size-3"
          >
            <path  
              strokeLinecap="round"       
              strokeLinejoin="round"   
              d="m8.25 4.5 7.5 7.5-7.5 7.5"  
            />  
          </svg>
        </span>
        <h2 className="text-sm font-normal">{"Home"}</h2>    
        <span> 
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"  
            strokeWidth="1.5"
            stroke="currentColor" 
            className="size-3" 
          >  
            <path  
              strokeLinecap="round"  
              strokeLinejoin="round"  
              d="m8.25 4.5 7.5 7.5-7.5 7.5"  
            />  
          </svg>  
        </span> 
        <h2 className="text-sm font-normal">{"Health"}</h2>
        <span>    
          <svg 
            xmlns="http://www.w3.org/2000/svg"  
            fill="none"
            viewBox="0 0 24 24" 
            strokeWidth="1.5"  
            stroke="currentColor"  
            className="size-3"    
          >
            <path   
              strokeLinecap="round"
              strokeLinejoin="round"    
              d="m8.25 4.5 7.5 7.5-7.5 7.5"  
            />
          </svg> 
        </span>
        <h2 className="text-sm font-semibold">{"Slimetics Discovery"}</h2>  
      </div>
    </div>
  );
};

export default Breadcrums;
